// Entry point for the build script in your package.json
// import "@hotwired/turbo-rails"
// import "./controllers"
// import "./tailadmin/index";

// import Rails from "@rails/ujs"
// Rails.start()

// Configure your Stimulus application
import "./controllers"
import "@hotwired/turbo-rails"

// Global 401 handler — when ANY fetch returns 401 (session expired, or a
// stale CSRF token after a timeout), redirect to login immediately instead
// of showing confusing errors. Covers both Devise's timeoutable 401 and the
// InvalidAuthenticityToken handler (which now returns 401 for XHR/fetch).
const originalFetch = window.fetch
let sessionRedirecting = false
window.fetch = async function (...args) {
  const response = await originalFetch.apply(this, args)
  if (response.status === 401 && !sessionRedirecting) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || ""
    // Only redirect for same-origin requests; skip session management endpoints
    if (!url.startsWith("http") && !url.includes("/session/")) {
      sessionRedirecting = true
      window.location.replace("/users/sign_in")
      // Halt the caller so it can't render an error alert over the redirect —
      // the page is navigating away, so this promise never needs to resolve.
      return new Promise(() => {})
    }
  }
  return response
}

// ActiveStorage Direct Uploads - files upload directly to S3
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Direct upload utility for certificate documents etc.
import "./utils/direct_upload"

// Guards modal backdrops against closing on text-selection drags that end
// outside the modal (registers a global pointerdown tracker + window helpers).
import "./utils/modal_backdrop_dismiss"

// Lets Windows mouse users scroll slideover tab strips: translates vertical
// wheel into horizontal scrolling over horizontally-scrollable strips.
import "./utils/horizontal_wheel_scroll"

// Client-side image resize for property photo uploads
import "./utils/image_resize"

// PDF thumbnail generator for client-side preview
import "./utils/pdf_thumbnail"

// Import Action Cable channels (makes consumer available globally)
import "./channels"

// Import timeline card with ActionCable (BEFORE tailadmin so timelineCard is defined before Alpine.start())
import "./components/timeline_card"

// Import TailAdmin
import "./tailadmin"

// search_title_persistence removed - was dead code (targeted elements that no longer exist)

// Mobile sidebar auto-close is now handled by Stimulus controller (mobile_sidebar_controller.js)

// Import property search functionality
import "./property_search"

// Import SignaturePad and make it globally available
import SignaturePad from "signature_pad"
window.SignaturePad = SignaturePad

// Import and make stacked list helpers globally available
import { shouldShowBackToTop, scrollToTopHelper, initMobileScrollHandlers, fillViewport } from "./components/stacked_list_manager"
window.shouldShowBackToTop = shouldShowBackToTop
window.scrollToTopHelper = scrollToTopHelper
window.initMobileScrollHandlers = initMobileScrollHandlers
window.fillViewport = fillViewport

// Import filter helpers for index views
import "./utils/filter_helpers"

// Import browser-image-compression for offline inspection photos
import imageCompression from "browser-image-compression"
window.imageCompression = imageCompression

// Import inspection storage, upload queue, and creator for offline inspections
import inspectionStorage from "./utils/inspection_storage"
import uploadQueue from "./services/upload_queue"
import inspectionCreator from "./services/inspection_creator"
window.inspectionStorage = inspectionStorage
window.uploadQueue = uploadQueue
window.inspectionCreator = inspectionCreator

// Create inspection offline-first (no server call)
// This must be global for Alpine.js to call it from the property show page
window.createOfflineInspection = async function(propertyId, propertyAddress) {
  try {
    const creator = window.inspectionCreator;

    // Create inspection client-side only
    const uuid = await creator.createInspection(propertyId, propertyAddress);

    // Redirect to inspection form
    window.location.href = `/inspections/${uuid}/form`;
  } catch (error) {
    console.error('Error creating inspection:', error);
    alert('Error creating inspection: ' + error.message);
  }
}

// Close app settings modal on successful form submission
document.addEventListener('turbo:submit-end', (event) => {
  const form = event.target

  // Check if this is an app installation form submission
  if (form.matches('[action="/app_installations"]') ||
      form.matches('[action*="/app_installations/"]')) {

    // If submission was successful and Alpine store is available
    if (event.detail.success && window.Alpine && window.Alpine.store && window.Alpine.store('modals')) {
      // Close the modal after a brief delay to allow flash message to appear
      setTimeout(() => {
        window.Alpine.store('modals').showSettingsModal = false
      }, 100)
    }
  }
})